import { NgModule } from '@angular/core';
import { ModalComponent } from './modal/modal.component';
import { LoaderComponent } from './loader/loader.component';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';

@NgModule({
  imports: [CommonModule, BrowserModule],
  declarations: [
    LoaderComponent,
    ModalComponent
  ],
  exports: [
    LoaderComponent,
    ModalComponent
  ]
})
export class ComponentsModule { }



// WEBPACK FOOTER //
// C:/ProactiView/ProactiView-Client/src/app/shared/components/index.ts